import { CountryCode } from '@quromedical/fhir-common';
import * as yup from 'yup';

const countryCodes = Object.values(CountryCode);
export const countrySchema = yup.string().required().oneOf(countryCodes);

// this handles the edge case where the second element of an array may be undefined or empty but
// this is fine since downstream consumers of this data should compact or clean this in some way
export const linesSchema = yup.mixed<string[] | undefined>().test({
  // the first line of the address is always required
  test: (lines = []) => lines[0]?.length > 0,
});

export const citySchema = yup.string().required();

export const postalCodeSchema = yup.string().required();
